export const encodeCachedPropertyUid = (uid) => `p${uid}`;
